export default [
  {
    key: 'actions',
    sortable: false
  },
  {
    key: 'type',
    sortable: false
  },
  {
    key: 'status',
    sortable: true
  },
  {
    key: 'price',
    sortable: true
  },
  {
    key: 'name',
    sortable: true
  },
  {
    key: 'full_address',
    sortable: true
  },
  {
    key: 'phone',
    sortable: true
  },
  {
    key: 'email',
    sortable: true
  },
  {
    key: 'date',
    label: "Date Added",
    sortable: true
  },
  {
    key: 'follow_up_date',
    label: "Follow Up Date",
    sortable: true
  },

  {
    key: 'potential_gci',
    label: 'Potential GCI',
    sortable: true
  },
  {
    key: 'potential_profit',
    sortable: false
  },
  {
    key: 'pipeline_rating',
    sortable: false
  },
  {
    key: 'transferred_from',
    sortable: true
  },
  {
    key: 'primary_source',
    label: 'Source',
    sortable: true
  },
];